<template>
  <div v-if="show_playlist_data">
    <div
      class="row playlist-container mb-4 mt-8"
      :style="{
        background: `url(${
          playlist?.type == 'audio'
            ? playlist?.imageLandScape
            : (playlist[0]?.episode != null
            ? (paths.episodeLandscapePath +
              playlist[0]?.episode?.image?.landscape)
            : (playlist[0]?.item
            ? (paths.landscapePath + playlist[0]?.item?.image?.landscape)
            : paths.default))
        })`,
        'background-size': 'cover',
        'background-position': 'center center',
        'background-repeat': 'no-repeat',
      }"
    >
      <div class="col-md-3 mb-5">
        <a
          :href="
            playlist?.type == 'audio'
              ? `/user/playlist/audio/${playlist.id}`
              : playlist[0]
              ? `/user/playlist/video/${playlist[0].playlist_id}`
              : '#'
          "
        >
          <img
            :src="
              playlist?.type == 'audio'
                ? playlist?.image
                : (playlist[0]?.episode != null
                ? (paths.episodePortraitPath +
                  playlist[0]?.episode?.image?.portrait)
                : (playlist[0]?.item
                ? (paths.portraitPath + playlist[0]?.item?.image?.portrait)
                : paths.default))
            "
            alt="playlist?.name"
          />
        </a>
        <div
          class="playlist-title d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap"
        >
          <h4
            class="font-bold from-stone-100"
            id="old-playlist-name"
            v-if="!editPlaylistName"
          >
            {{
              playlist?.type == 'audio'
                ? playlist?.name
                : playlist[0]
                ? playlist[0]?.name
                : playlist.name
            }}
          </h4>
          <i
            class="las la-edit"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Edit Playlist Name"
            id="edit-playlist-name"
            @click="editPlaylistName = !editPlaylistName"
            v-if="!editPlaylistName"
          ></i>
          <div
            class="playlist-name-input"
            v-if="editPlaylistName"
            ref="playlistName"
            v-click-outside="onClickOutside"
          >
            <div
              class="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap description-containtainer"
            >
              <input
                type="text"
                class="form-control"
                id="playlist-name"
                v-model="playlistName"
                @input="validatePlaylistName()"
                maxlength="20"
              />
              <div class="description-btn">
                <i
                  class="las la-check"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  :data-id="
                    playlist?.type == 'audio'
                      ? playlist?.id
                      : playlist[0]?.playlist_id
                  "
                  title="Save Playlist Name"
                  id="save-edit-playlist-name"
                  @click="
                    savePlaylistName(
                      playlist?.type == 'audio'
                        ? playlist?.id
                        : playlist[0]
                        ? playlist[0]?.playlist_id
                        : playlist.id
                    )
                  "
                ></i>
                <i
                  class="las la-times"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Cancel Playlist Name"
                  id="cancel-edit-playlist-name"
                  @click="editPlaylistName = !editPlaylistName"
                ></i>
              </div>
            </div>
          </div>
        </div>

        <div
          class="playlist-count-from-stone-10 justify-content-between align-items-center flex-wrap flex-md-nowrap0"
        >
          <span>
            {{
              playlist?.type == 'audio'
                ? playlist?.songs?.length
                : playlist.length ?? 0
            }}

            {{ playlist?.type == 'audio' ? 'songs' : 'videos' }}</span
          >
          <i
            class="fa fa-ellipsis-v"
            id="icon-open-modal-detele"
            @click="deletePlaylistModal = !deletePlaylistModal"
          ></i>

          <div
            class="playlist-count-from-stone-10-delete"
            id="playlist-count-from-stone-10-delete"
            v-if="deletePlaylistModal"
            v-click-outside="onClickOutside"
          >
            <span
              class="span-2"
              id="delete-playlist"
              data-toggle="modal"
              data-target="#deletePlaylistModal"
              :data-id="
                playlist?.type == 'audio'
                  ? playlist?.id
                  : playlist[0]
                  ? playlist[0]?.playlist_id
                  : playlist.id
              "
              @click="
                deletePlaylist(
                  playlist?.type == 'audio'
                    ? playlist?.id
                    : playlist[0]
                    ? playlist[0]?.playlist_id
                    : playlist.id
                )
              "
            >
              <i
                class="fa fa-trash float-right mr-2"
                data-toggle="tooltip"
                data-placement="bottom"
                title="Delete Playlist"
              ></i>
              Delete Playlist
            </span>
          </div>
        </div>

        <div
          class="playlist-description d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap mb-9"
        >
          <p id="p-playlist-description" v-if="!editDescription">
            {{
              playlist?.type == 'audio'
                ? playlist?.description
                : playlist[0]
                ? playlist[0]?.description
                : playlist.description
            }}
          </p>
          <i
            class="las la-edit"
            data-toggle="tooltip"
            data-placement="bottom"
            title="Edit Playlist Description"
            id="edit-playlist-description-icon"
            @click="editDescription = !editDescription"
            v-if="!editDescription"
          ></i>

          <div
            class="playlist-description-input"
            v-if="editDescription"
            v-click-outside="onClickOutside"
          >
            <div
              class="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap flex-col description-containtainer"
            >
              <textarea
                type="text"
                id="playlist-description"
                placeholder="Playlist Description"
                class="form-control"
                name="description"
                style="height: 100px; resize: none"
                v-model="playlistDescription"
              >
              {{
                  playlist?.type == 'audio'
                    ? playlist?.description
                    : playlist[0]
                    ? playlist[0]?.description
                    : playlist.description
                }}
              </textarea>
              <div class="description-btn">
                <i
                  class="las la-check"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  :data-id="
                    playlist?.type == 'audio'
                      ? playlist?.id
                      : playlist[0]
                      ? playlist[0]?.playlist_id
                      : playlist.id
                  "
                  title="Save Playlist Description"
                  id="save-edit-playlist-description"
                  @click="
                    saveDescription(
                      playlist?.type == 'audio'
                        ? playlist?.id
                        : playlist[0]
                        ? playlist[0]?.playlist_id
                        : playlist.id
                    )
                  "
                ></i>
                <i
                  class="las la-times"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Cancel Playlist Description"
                  id="cancel-edit-playlist-description"
                  @click="editDescription = !editDescription"
                ></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-9" id="playlist-items">
        <song-list
          v-if="playlist.type == 'audio'"
          :playlist="playlist"
          @removeFromPlaylist="removeFromPlaylist"
        ></song-list>
        <video-list
          v-else
          :playlist="playlist"
          @removeFromPlaylist="removeFromPlaylist"
          :paths="paths"
        ></video-list>
      </div>
    </div>
  </div>
  <div v-else>
    <!-- <song-list :playlist="playlist"></song-list> -->
    <p>Playlist not found</p>
  </div>
</template>

<script>
import SongList from './song-list.vue';
import VideoList from './video-list.vue';
import EmptyPlaylist from './empty-list.vue';
import axios from 'axios';
import vClickOutside from 'v-click-outside';

export default {
  name: 'library-playlist',
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    SongList,
    VideoList,
  },
  props: {
    playlist_id: {
      type: Number,
      required: true,
    },
    playlist: {
      type: Object | Array,
      required: false,
    },
    show_playlist_data: {
      type: Boolean,
      required: true,
      default: false,
    },
    paths: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editDescription: false,
      deletePlaylistModal: false,
      editPlaylistName: false,
      errorMessage: '',
      isPopupVisible: false,
    };
  },
  computed: {
    playlistDescription: {
      get() {
        return this.playlist?.type == 'audio'
          ? this.playlist?.description
          : this.playlist[0]
          ? this.playlist[0]?.description
          : this.playlist.description;
      },
      set(value) {
        // Update the description of the playlist here
        if (this.playlist?.type == 'audio') {
          this.playlist.description = value;
        } else {
          this.playlist[0]
            ? (this.playlist[0].description = value)
            : (this.playlist.description = value);
        }
      },
    },
    playlistName: {
      get() {
        return this.playlist?.type == 'audio'
          ? this.playlist?.name
          : this.playlist[0]
          ? this.playlist[0]?.name
          : this.playlist.name;
      },
      set(value) {
        if (this.playlist?.type == 'audio') {
          this.playlist.name = value;
        } else {
          this.playlist[0]
            ? (this.playlist[0].name = value)
            : (this.playlist.name = value);
        }
      },
    },
  },

  methods: {
    onClickOutside(event) {
      if (this.editPlaylistName) {
        this.editPlaylistName = false;
      }
      if (this.deletePlaylistModal) {
        this.deletePlaylistModal = false;
      }
      if (this.editDescription) {
        this.editDescription = false;
      }
    },
    validatePlaylistName() {
      if (this.playlistName === '') {
        this.errorMessage = 'Playlist name cannot be empty';
        this.isPopupVisible = true;
      } else if (this.playlistName.length > 10) {
        this.errorMessage = 'Playlist name cannot exceed 10 characters';
        this.isPopupVisible = true;
      } else {
        this.errorMessage = '';
        this.isPopupVisible = false;
      }
    },
    removeFromPlaylist(song_id, type) {
      if (type == 'audio') {
        const className = document.getElementsByClassName(`song_id_${song_id}`);
        for (let i = 0; i < className.length; i++) {
          className[i].style.display = 'none';
        }
      } else {
        const className = document.getElementsByClassName(
          `video_id_${song_id}`
        );
        for (let i = 0; i < className.length; i++) {
          className[i].style.display = 'none';
        }
      }
    },
    async saveDescription(playlist_id) {
      try {
        const response = await axios.patch(`/user/playlist/${playlist_id}`, {
          description: this.playlistDescription,
        });
        notify('success', 'Playlist description updated successfully');
        this.editDescription = false;
      } catch (error) {
        notify(
          'error',
          'An error occurred while updating playlist description'
        );
      }
    },
    async deletePlaylist(playlist_id) {
      try {
        const response = await axios.delete(`/user/playlist/${playlist_id}`);
        notify('success', 'Playlist deleted successfully');
        this.deletePlaylistModal = false;
        this.$emit('deleted', playlist_id);
      } catch (error) {
        notify('error', 'An error occurred while deleting playlist');
      }
    },
    async savePlaylistName(playlist_id) {
      try {
        const response = await axios.patch(`/user/playlist/${playlist_id}`, {
          name: this.playlistName,
        });
        notify('success', 'Playlist name updated successfully');
        this.editPlaylistName = false;
        this.$emit('updatedName', playlist_id, this.playlistName);
      } catch (error) {
        console.log(error);
        notify('error', 'An error occurred while updating playlist name');
      }
    },

    getImageUrl(image) {
      if (image) {
        return this.currentUrl + image;
      } else {
        return this.currentUrl + 'images/playlist.png';
      }
    },
  },
  // clicking outside the modal will close it
  mounted() {
    // document.addEventListener('click', (e) => {
    //   if (e.target.id !== 'icon-open-modal-detele') {
    //     this.deletePlaylistModal = false;
    //   }
    // });
  },
  updated() {
    // console.log(this.playlist);

    // console.log(this.playlist?.image);
  }, 
};
</script>
